export default {
  download: {
    appName: 'Blueshark App',
    slogan: '智能出行，一手掌握',
    tips1: 'Blueshark App使用設備系統要求',
    tips2: 'Android系統需8.0及以上，iOS系統需12及以上',
    weTips1: '當前環境不支持下載安裝',
    weTips2: '1. 請選擇右上角···使用瀏覽器打開',
    weTips3: '2. 瀏覽器打開後即可下載安裝',
    iosListTitle: '請選擇你的國家或地區',
    androidListTitle: '請選擇你所使用的App版本',
    ChineseVersion: '中國大陸地區版本',
    InoternationalVersion: '其他國際地區版本',
    asian: 'Asia-pacific region',
    european: 'European region'
  },
  support: {
    title: '服務支持',
    productAndService: '產品支持及服務',
    service: '維護保養及服務政策',
    toService: '點擊查詢產品售後維護保養政策',
    view: '立即查看',
    product: '產品使用手冊',
    toProduct: '點擊查看及下載產品說明及使用手冊',
    chooseModel: '請根據您所購買的產品選擇相應的車型',
    rModel: '藍鯊 R 系列',
    hModel: '藍鯊 H 系列'
  },
  R1config: {
    battery: '電池',
    capacity: '電池容量',
    NEDC: 'NEDC 續航',
    powerType: '電芯類型',
    automotive: '汽車級鋰電',
    charger: '充電器',
    performance: '性能',
    motor: '馬達',
    highSpeedMotor: '高速無刷永磁齒輪電機',
    topSpeed: '極速',
    ratedPower: '額定功率',
    peakPower: '峰值功率',
    torque: '扭力',
    gradability: '爬坡性能',
    turbo: 'Turbo 競速模式',
    yes: '有',
    no: '無',
    mam: 'MAM',
    smart: '智慧',
    panel: '儀表',
    IPSScreen: '10 英吋全彩高解析 IPS 螢幕',
    LCDScreen: '10 英吋液晶段碼屏',
    bluetooth: '藍牙導航',
    frontalCamera: '前攝影機',
    RearCamera: '後攝影機',
    optional: '選裝',
    RAM: '內存',
    viewWhenTurn: '有 (轉彎時顯示後方影像)',
    remainRange: '剩餘里程',
    bluesharkApp: '藍鯊 App',
    wireless: '無線連接',
    sensors: '傳感器數量',
    upgrade: 'OTA 升級',
    safe: '安全',
    smartKey: '藍牙智慧鑰匙',
    steeringLock: '電子龍頭鎖',
    seatLock: '電子座桶鎖',
    triMode: '三模定位',
    brake: '剎車',
    CBS: 'CBS 前後聯動液壓雙碟剎',
    ADAS: 'ADAS',
    remoteAlarm: '遠程報警',
    sideStand: '邊撐斷電',
    virtualVroom: '虛擬引擎音',
    light: '燈光',
    autoHeadlight: '感應大燈',
    turnSignal: '轉向燈',
    HazardLight: '雙閃燈',
    seatLight: '座桶照明燈',
    carpetLight: '氛圍地毯燈',
    multimedia: '多媒體',
    speaker: '揚聲器',
    HighPowerSpeaker: '大功率揚聲器',
    basic: '基礎',
    size: '車體尺寸',
    LWH: '(長*寬*高)',
    wheelbase: '軸距',
    tire: '輪胎',
    front: '前',
    rear: '後',
    groundClearance: '離地間隙',
    weight: '裸車重量',
    colors: '車身顏色',
    color: '秋月白 / 雲墨黑 / 綠如藍 / 鬆濤綠 / 椰林棕'
  },
  H1Product: {
    firstBG: {
      title: '藍鯊 H1',
      info: '智慧電動機車',
      slogan: ' '
    },
    colorName: {
      while: '柔沙白',
      blue: '海鹽藍',
      green: '海藻綠',
      pink: '珊瑚粉',
      black: '礁石黑'
    },
    colorNameSlogan: {
      while: ' ',
      blue: ' ',
      green: ' ',
      pink: ' ',
      black: ' '
    },
    performance: {
      title: '性能 以快為先',
      subTitle: '汽车级齿轮减速箱设计及直驱技术，动力传递高效、稳定。',
      maxPower: '最大功率',
      maxSpeed: '最高速度',
      torque: '轮上扭矩',
      climbing: '爬坡能力',
      swerve: '转弯半径'
    },
    gear: {
      title: '矢量算法 駕駛平順',
      subTitle: '3 種騎行模式，2 種輔助模式',
      model1: ' ',
      model2: ' ',
      model3: ' '
    },
    control: {
      title: '精準操控',
      info: '輕鬆駕馭任何路況'
    },
    battery: {
      title: '安全升級 智能高效',
      info: '藍鯊動力鋰電池',
      fastCharge: '快速充電',
      largeCapacity: '超大容量',
      endurance: '續航裡程',
      highlight1: '更安全',
      highlight2: '更可靠',
      highlightInfo1: ' ', // 无繁体文案
      highlightInfo2: ' ', // 无繁体文案
      highlightInfo3: ' ', // 无繁体文案
      highlightInfo4: ' ', // 无繁体文案
      highlightInfo5: ' ' // 无繁体文案
    },
    cab: {
      title: '藍鯊智慧換電系統',
      slogan: ' ', // 无繁体文案
      noFeelChange: '無感換電',
      speedSwapping: '極速充電',
      info1: '3 秒换电',
      info2: '仅需两步，即换即走',
      info3: '2h 快速充电',
      info4: '单日可换电 150 次'
    },
    mam: {
      slogan: ' '
    },
    chip: {
      title: '最強大腦',
      subTitle2: '動力控製域 + 系統控制域',
      highDot1: '驅動控製 MCU',
      highDot2: '電池管理 BMS',
      highDot3: '能源分配',
      content1:
        '可通過電門、製動燈執行機構感知駕駛者的操作意圖，並結合車輛狀態和環境狀態，自動配置三電系統最佳工作狀態，實現駕乘感受和節能的雙重優化。',
      content2:
        '動力控製域實時監控動力系統各單元工作狀態，實時算力檢測系統異常，以第一安全級別保障核心系統安全，從而保障駕駛人員和環境安全。',
      content3: '駕駛的不再是簡單的交通工具，而是一種智能設備的延伸。',
      content4:
        '中控系統、車載信息娛樂系統、流媒體及行車數據，通過系統控製域平台主導管理，更高的集成度，更快的反應速度，讓騎乘融入生活。'
    },
    os: {
      title: '智能協助 高效出行',
      info1: '新一代智慧車機系統 ArkRide OS 2.0',
      info2: '模塊化設計，多樣體驗',
      info3: '4G 加持，OTA 輕鬆升級',
      content1: '啟動速度提升',
      content2: '穩定性提升',
      content3: '指令反餽速度'
    },
    screen: {
      title: '超大螢幕 數據更清晰',
      info: '10 英吋全彩高解析 IPS 螢幕，自適應亮度調整，強光下依舊清晰可見'
    },
    handlebar: {
      title: '全新手把 玩趣盡在掌握',
      info: ' ', // 无繁体文案
      content: ' ' // 无繁体文案
    },
    key: {
      title: '以簡馭繁<br/>一鍵啟動 無需多餘動作',
      info: '蓝牙智能钥匙，用车全程无感操作，告别钥匙的繁琐',
      highDot1: '藍牙感應解鎖',
      highDot2: '手機 App 解鎖'
    },
    app: {
      title1: '藍鯊 App',
      title2: '更智能 更便捷',
      info: '车况信息，一手掌握',
      highDot1: '車輛定位',
      highDot2: '電量統計',
      highDot3: '行駛軌跡',
      highDot4: '裡程記錄'
    },
    bikeColor: {
      title: '多彩多姿 激情澎湃'
    },
    config: {
      title: '藍鯊 H1 性能參數',
      c1: '額定功率',
      c2: '電池容量',
      c3: '極速',
      c4: '剎車系統',
      c5: '前後碟剎',
      c6: '智慧車機',
      c7: '最大載重',
      c8: '車重（含電池）',
      c9: '中控儀表',
      c10: '10 英吋全彩高解析 IPS 螢幕',
      c11: '軸距',
      c12: '座高',
      c13: '峰值功率',
      c14: '續航裡程',
      c15: '智慧中控系統',
      c16: '動力&系統控製域',
      c17: '智慧輔助功能',
      c18: '啟動方式',
      c19: '藍牙智慧鑰匙',
      c21: '配色',
      c22: '轉彎半徑',
      c23: '尺寸',
      c24: '離地高度'
    }
  },
  iosAsianCountryList: [
    { country: 'Australia', url: 'https://apps.apple.com/au/app/id1512077089' },
    { country: 'Cambodia', url: 'https://apps.apple.com/kh/app/id1512077089' },
    { country: 'China', url: 'https://apps.apple.com/cn/app/id1455603928' },
    { country: 'HongKong', url: 'https://apps.apple.com/hk/app/id1512077089' },
    { country: 'Indonesia', url: 'https://apps.apple.com/id/app/id1512077089' },
    { country: 'Korea', url: 'https://apps.apple.com/kr/app/id1512077089' },
    { country: 'Macao', url: 'https://apps.apple.com/mo/app/id1512077089' },
    { country: 'Malaysia', url: 'https://apps.apple.com/my/app/id1512077089' },
    {
      country: 'Philippines',
      url: 'https://apps.apple.com/ph/app/id1512077089'
    },
    { country: 'Singapore', url: 'https://apps.apple.com/sg/app/id1512077089' },
    { country: 'Taiwan', url: 'https://apps.apple.com/tw/app/id1512077089' },
    { country: 'Thailand', url: 'https://apps.apple.com/th/app/id1512077089' },
    { country: 'Vietnam', url: 'https://apps.apple.com/vn/app/id1512077089' }
  ],
  iosEuropeanCountryList: [
    { country: 'Albania', url: 'https://apps.apple.com/al/app/id1512077089' },
    { country: 'Austria', url: 'https://apps.apple.com/at/app/id1512077089' },
    { country: 'Belarus', url: 'https://apps.apple.com/by/app/id1512077089' },
    { country: 'Belgium', url: 'https://apps.apple.com/be/app/id1512077089' },
    {
      country: 'Bosnia & Herzegovina',
      url: 'https://apps.apple.com/ba/app/id1512077089'
    },
    { country: 'Bulgaria', url: 'https://apps.apple.com/bg/app/id1512077089' },
    { country: 'Croatia', url: 'https://apps.apple.com/hr/app/id1512077089' },
    {
      country: 'Czech Republic',
      url: 'https://apps.apple.com/cz/app/id1512077089'
    },
    { country: 'Denmark', url: 'https://apps.apple.com/dk/app/id1512077089' },
    { country: 'Estonia', url: 'https://apps.apple.com/ee/app/id1512077089' },
    { country: 'France', url: 'https://apps.apple.com/fr/app/id1512077089' },
    { country: 'Finland', url: 'https://apps.apple.com/fi/app/id1512077089' },
    { country: 'Germany', url: 'https://apps.apple.com/de/app/id1512077089' },
    { country: 'Greece', url: 'https://apps.apple.com/gr/app/id1512077089' },
    { country: 'Hungary', url: 'https://apps.apple.com/hu/app/id1512077089' },
    { country: 'Iceland', url: 'https://apps.apple.com/is/app/id1512077089' },
    { country: 'Italy', url: 'https://apps.apple.com/it/app/id1512077089' },
    { country: 'Ireland', url: 'https://apps.apple.com/ie/app/id1512077089' },
    { country: 'Latvia', url: 'https://apps.apple.com/lv/app/id1512077089' },
    { country: 'Lithuania', url: 'https://apps.apple.com/lt/app/id1512077089' },
    {
      country: 'Luxembourg',
      url: 'https://apps.apple.com/lu/app/id1512077089'
    },
    { country: 'Malta', url: 'https://apps.apple.com/mt/app/id1512077089' },
    { country: 'Moldova', url: 'https://apps.apple.com/md/app/id1512077089' },
    {
      country: 'Montenegro',
      url: 'https://apps.apple.com/me/app/id1512077089'
    },
    {
      country: 'Netherlands',
      url: 'https://apps.apple.com/nl/app/id1512077089'
    },
    { country: 'Norway', url: 'https://apps.apple.com/no/app/id1512077089' },
    { country: 'Poland', url: 'https://apps.apple.com/pl/app/id1512077089' },
    { country: 'Portugal', url: 'https://apps.apple.com/pt/app/id1512077089' },
    { country: 'Romania', url: 'https://apps.apple.com/ro/app/id1512077089' },
    { country: 'Russia', url: 'https://apps.apple.com/ru/app/id1512077089' },
    { country: 'Serbia', url: 'https://apps.apple.com/rs/app/id1512077089' },
    { country: 'Slovakia', url: 'https://apps.apple.com/sk/app/id1512077089' },
    { country: 'Slovenia', url: 'https://apps.apple.com/si/app/id1512077089' },
    { country: 'Spain', url: 'https://apps.apple.com/es/app/id1512077089' },
    { country: 'Sweden', url: 'https://apps.apple.com/se/app/id1512077089' },
    {
      country: 'Switzerland',
      url: 'https://apps.apple.com/ch/app/id1512077089'
    },
    { country: 'Ukraine', url: 'https://apps.apple.com/ua/app/id1512077089' },
    {
      country: 'United Kingdom',
      url: 'https://apps.apple.com/gb/app/id1512077089'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/i18n/tc.js